import React from 'react';
import styled from 'styled-components';
import { printThemeVars } from '../../utils/helpers';
import { lightTheme, darkTheme } from '@spotify-internal/encore-foundation';
const themeMap = {
    encoreLight: {
        values: lightTheme.base,
    },
    encoreDark: {
        values: darkTheme.base,
    },
};
const ThemedGroup = styled.div `
  ${({ customTheme }) => printThemeVars(customTheme)}
`;
const UnthemedGroup = styled.div ``;
export const getThemeValues = (themeName) => themeMap[themeName];
const Theme = ({ themeName, children, }) => {
    if (!themeName || !getThemeValues(themeName)) {
        return React.createElement(UnthemedGroup, null, children);
    }
    return (React.createElement(ThemedGroup, { customTheme: getThemeValues(themeName) }, children));
};
export default Theme;
//# sourceMappingURL=index.js.map